import { farloUiMastheadCarousel } from "./vendors/farlo-ui-masthead-carousel";

((document, window, history) => {
	const pushState = history.pushState;

	function toggleActiveClass() {
		const div = document.getElementsByClassName('rank-math-list-item');

		for (let i = 0; i < div.length; i ++) {
		  div[ i ].addEventListener('click', function() {
				if (this.classList.contains('rank-math-list-item--active')) {
			  this.classList.remove('rank-math-list-item--active');
			  // Collapse the accordion smoothly
			  var content = this.querySelector('.rank-math-answer');
			  content.style.height = '0';
				} else {
			  // Expand the accordion smoothly
			  this.classList.add('rank-math-list-item--active');
			  var content = this.querySelector('.rank-math-answer'); // Fix missing dot in selector
			  content.style.height = content.scrollHeight + 'px';
				}
		  });
		}
	  }

	  function initializeLightboxes() {
        // Handle original buttons
        const toggleButtons = document.querySelectorAll('.site-farlo-ui-lightbox__toggle .button');
        toggleButtons.forEach(button => {
            const buttonId = button.getAttribute('id');
            const lightboxId = button.getAttribute('aria-label').replace('Toggle ', '');
            
            button.addEventListener('click', function() {
                const lightbox = document.getElementById(lightboxId);
                if (lightbox) {
                    if (lightbox.style.display === 'none' || lightbox.style.display === '') {
                        lightbox.style.display = 'block';
                        document.body.classList.add('site-farlo-ui-lightbox__open');
                    } else {
                        lightbox.style.display = 'none';
                        document.body.classList.remove('site-farlo-ui-lightbox__open');
                    }
                }
            });
        });

        // Handle additional buttons
		const additionalButtonContainers = document.querySelectorAll('.lightbox-button');
        
        additionalButtonContainers.forEach(button => {
			const buttonLink = button.querySelector('.wp-block-button__link')
            const lightboxId = Array.from(button.classList).find(className => className.startsWith('site-farlo-ui-lightbox-block_'));

            buttonLink.addEventListener('click', function(event) {
                event.preventDefault(); // Prevent default anchor behavior
                const lightbox = document.getElementById(lightboxId);
                if (lightbox) {
                    if (lightbox.style.display === 'none' || lightbox.style.display === '') {
                        lightbox.style.display = 'block';
                        document.body.classList.add('site-farlo-ui-lightbox__open');
                    } else {
                        lightbox.style.display = 'none';
                        document.body.classList.remove('site-farlo-ui-lightbox__open');
                    }
                }
            });
        });

        // Handle close buttons
        const closeButtons = document.querySelectorAll('.site-farlo-ui-lightbox__close');
        closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', function() {
                const lightbox = closeButton.closest('.site-farlo-ui-lightbox');
                if (lightbox) {
                    lightbox.style.display = 'none';
                    document.body.classList.remove('site-farlo-ui-lightbox__open');
                }
            });
        });
    }

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	function jumpToAnchor(event) {
		// Prevent the default behavior of the link
		event.preventDefault();

		// Get the target element using the href value of the clicked link
		const targetId = event.target.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);

		// Check if the target element exists
		if (targetElement) {
		  // Add the 'rank-math-answer--active' class to the parent element of the target
		  targetElement.classList.add('rank-math-list-item--active');

		  // Scroll to the target element
		  targetElement.scrollIntoView({ behavior: 'smooth' });
		}
	  }

	  // Function to add 'scrolled' class to the body when not at the top
	function addScrolledClass() {
		const body = document.body;

		// Event listener for the scroll event
		window.addEventListener('scroll', function() {
			// Check if the page is scrolled beyond the top
			if (window.scrollY > 0) {
				// Add the 'scrolled' class to the body
				body.classList.add('scrolled');
			} else {
				// Remove the 'scrolled' class if at the top
				body.classList.remove('scrolled');
			}
		});
	}

	// Call the function to set up the event listener
	addScrolledClass();

// default navigation subnav
function navigation() {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach(function(item) {
        const subMenu = item.querySelector('.sub-menu');
        const link = item.querySelector('a');
        let toggleOpened = false; // Track if the submenu is opened

        // Toggle submenu visibility
        item.addEventListener('click', function(event) {
            if (!toggleOpened) {
                event.preventDefault(); // Prevent navigation if the submenu is closed
                closeAllSubmenus();
                subMenu.classList.add('sub-menu--active');
                link.classList.add('menu-item-has-children--active');
                toggleOpened = true; // Mark submenu as opened
            } else {
                // Allow navigation to the URL on the second click
                toggleOpened = false; // Reset the toggle state
            }
            event.stopPropagation();
        });

        // Close submenu when clicking anywhere else on the page
        document.addEventListener('click', function(event) {
            let target = event.target;
            let isMenuItem = false;

            while (target !== document) {
                if (target.classList.contains('menu-item-has-children')) {
                    isMenuItem = true;
                    break;
                }
                target = target.parentNode;
            }

            if (!isMenuItem) {
                closeAllSubmenus();
            }
        });

        function closeAllSubmenus() {
            menuItems.forEach(function(item) {
                const subMenu = item.querySelector('.sub-menu');
                subMenu.classList.remove('sub-menu--active');
                const link = item.querySelector('a');
                link.classList.remove('menu-item-has-children--active');
                const parentItem = item.querySelector('.menu-item-has-children');
                if (parentItem) {
                    parentItem.dataset.toggleOpened = 'false';
                }
            });
        }
    });
}


	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;

		if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}

	if (document.querySelector('.wp-block-embed')) {
		document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
		  const embedDiv = document.createElement('div');

		  if (!(_sel.querySelector('.wp-block-embed__player'))) {
				embedDiv.className = 'wp-block-embed__player';
				_sel.append(embedDiv);

				embedDiv.addEventListener('click', (e) => {
			  const iframe = e.currentTarget.parentNode.querySelector('iframe');
			  const dataSrc = iframe.getAttribute('data-src');

			  e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

			  if (dataSrc) {
						iframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
			  } else {
						const src = iframe.getAttribute('src');
						iframe.setAttribute('src', src + '&autoplay=1&playsinline=1&muted=1');
			  }
				});
		  }
		});
	  }

	function playVideoOnScroll() {
		const videoWrapper = document.querySelector('.wp-block-embed__wrapper');
		const videoPlayer = videoWrapper.querySelector('.wp-block-embed__player');
		const videoIframe = videoWrapper.querySelector('iframe');
		const videoSrc = videoIframe.getAttribute('data-src');
		const isVideoPlaying = () => videoWrapper.classList.contains('wp-block-embed__wrapper--is-playing');

		let isVideoLoaded = false;

		function playVideo() {
		  if (!isVideoPlaying()) {
				videoWrapper.classList.add('wp-block-embed__wrapper--is-playing');
				if (videoSrc) {
			  videoIframe.setAttribute('src', videoSrc + '&muted=1&autoplay=1&playsinline=1');
				} else {
			  const src = videoIframe.getAttribute('src');
			  videoIframe.setAttribute('src', src + '&muted=1&autoplay=1&playsinline=1');
				}
		  }
		}

		function pauseVideo() {
		  if (isVideoPlaying()) {
				videoWrapper.classList.remove('wp-block-embed__wrapper--is-playing');
				videoIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		  }
		}

		function handleScroll() {
		  const rect = videoPlayer.getBoundingClientRect();
		  const isFullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

		  if (isFullyVisible && !isVideoLoaded) {
				playVideo();
				isVideoLoaded = true;
		  } else if (!isFullyVisible && isVideoLoaded) {
				pauseVideo();
				isVideoLoaded = false;
		  }
		}

		// Attach scroll event listener
		window.addEventListener('scroll', handleScroll);
	  }

	  const checkInputValue = (_inp) => {
		if (_inp.value) {
			_inp.parentElement.classList.add('form-item-active');
		} else {
			_inp.parentElement.classList.remove('form-item-active');
		}
	};

	  document.querySelectorAll('.gfield input').forEach((_inp) => {
		const parentDiv = _inp.closest('.gfield');

		_inp.addEventListener('focus', () => {
		  parentDiv.classList.add('form-item-active');
		});

		_inp.addEventListener('blur', () => {
		  parentDiv.classList.remove('form-item-active');
		  checkInputValue(_inp);
		});

		checkInputValue(_inp);
	  });

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	function storeEmail() {
		const emailInput = document.querySelector('#input_5_1'); // Change this selector to match your input field
		const submitButton = document.querySelector('#gform_submit_button_5'); // Change this selector to match your submit button

		submitButton.addEventListener('click', function() {
			const email = emailInput.value;
			localStorage.setItem('storedEmail', email);
		});
	}

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation__nav--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('sub-menu--active');
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('menu-item-has-children--active');
			}

			if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function importantInformationBanner() {
		const infoBanner = document.querySelector('.site-important-information-banner');
		const closeButtons = [];

		closeButtons.push(infoBanner.querySelector('.site-farlo-ui-modal__inner-close'));
		closeButtons.push(infoBanner.querySelector('.site-farlo-ui-modal__close'));
		closeButtons.push(infoBanner.querySelector('.button-book'));

		function setCookie(name, value, days) {
			let expires = '';
			if (days) {
				const date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = '; expires=' + date.toUTCString();
			}
			document.cookie = name + '=' + (value || '') + expires + '; path=/';
		}

		function getCookie(cName) {
			let i, x, y;
			const ARRcookies = document.cookie.split(';');
			for (i = 0; i < ARRcookies.length; i ++) {
				x = ARRcookies[ i ].substr(0, ARRcookies[ i ].indexOf('='));
				y = ARRcookies[ i ].substr(ARRcookies[ i ].indexOf('=') + 1);
				x = x.replace(/^\s+|\s+$/g, '');
				if (x === cName) {
					return unescape(y);
				}
			}
		}

		closeButtons.forEach((_sel) => {
			_sel.addEventListener('click', () => {
				 setCookie('informationBannerSeen', true, 432E3);

				infoBanner.classList.add('site-important-information-banner--is-hidden');
			});
		});

		
			
		
	}

	document.addEventListener('DOMContentLoaded', () => {

		// if (document.querySelector('.site-masthead__image')) {
		// 	document.querySelectorAll('[farlo-ui="slider"]').forEach((_sel) => {
		// 		farloUiMastheadCarousel(_sel);
		// 	});
		// }
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
			navigation();

			document.querySelector('.site-navigation').querySelectorAll('.about-link').forEach((_sel) => {
				smoothScroll(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});

			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					farloUiMcSignup(document.querySelector('#' + e.currentTarget.dataset.crmButtonFor));
				});
			});
		}

		if (document.querySelector('.site-important-information-banner')) {
			importantInformationBanner();
		}

		if (document.querySelector('wp-block-embed')) {
			playVideoOnScroll();
		}

		if (document.querySelector('.rank-math-list-item')) {
			toggleActiveClass();
		}

		if (document.querySelector('#gform_5')) {
			storeEmail();
		}

		if (document.querySelector('.faq-button')) {
			const faqButton = document.querySelector('.faq-button');
			faqButton.addEventListener('click', function(event) {
				jumpToAnchor(event);
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox')){
			initializeLightboxes();
		}


	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
